<template>
  <div class="iDalgo-Result-Other">
    <i-dalgo-section-min
      v-for="(section, key) in players"
      :section="section"
      :total="count"
      :active="true"
      :key="`sectionResult-${key}`" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import iDalgoSectionMin from '@/components/iDalgo-Section-Min'

export default {
  name: 'iDalgo-Result-Other',
  components: {
    iDalgoSectionMin
  },
  computed: {
    ...mapGetters({
      count: 'results/getCount',
      players: 'results/getTemplatePlayers'
    })
  },
  methods: {},
  data () {
    return {
    }
  },
  mounted () {
    this.$store.dispatch('results/getData', this.$route.params.id)
      .then(() => {

      })
  }
}
</script>

<style lang="scss">
.iDalgo-Result-Other {
  font-family: "source_sans_proregular", sans-serif;
  padding-bottom: 42px;
}
</style>



// WEBPACK FOOTER //
// src/views/iDalgo-Result-Other.vue